import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const utilsAPI = createApi({
    reducerPath: "utilsAPI",
    baseQuery,
    endpoints: (builder) => ({
        getUploadNDownloadURLs: builder.mutation({
            query: ({ fileKey, contentType, category }) => {
                let apiUrl = `/upload?fileKey=${fileKey}&contentType=${contentType}&category=${category}`;
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        })
    }),
});

export const { 
    useGetUploadNDownloadURLsMutation,
} = utilsAPI;

export default utilsAPI;